import React from 'react';
import DriverFlowButton from './DriverFlowButton';
import { FlowEnums } from '@/central-atoms/everest-fleet-pwa/enums';
import i18n from '@/lang/i18n';

type FlowTypes = FlowEnums;

interface DriverFlowButtonCardProps {
  disableCheckIn: boolean,
  disableLogin: boolean,
  disableRoster: boolean,
  /** Razorpay top-up through Everest; only offered when `driver_details.topup.enabled` is sent. */
  showTopup?: boolean,
  handleFlowStart: (type: FlowTypes) => void
}

const DriverFlowButtonCard: React.FC<DriverFlowButtonCardProps> = ({ disableCheckIn, disableLogin, disableRoster, showTopup = false, handleFlowStart }) => {
  const handleButtonClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>, type: FlowTypes) => {
    handleFlowStart(type);
  }
  return (
    <div className="rounded-[30px] shadow-[0px_4px_27px_12px_#0a9b9b17] bg-white overflow-hidden flex w-100 flex flex-wrap py-[31px] px-0 2xs:px-[31px] mb-8">
      <div className="w-1/2 flex items-center justify-center pb-[18px]">
        <DriverFlowButton disabled={disableCheckIn} text={i18n.t("checkInDriver")} iconType={FlowEnums.CHECK_IN} onClick={(e) => handleButtonClick(e, FlowEnums.CHECK_IN)} />
      </div>
      <div className="w-1/2 flex items-center justify-center pb-[18px]">
        <DriverFlowButton disabled={disableLogin} text={i18n.t("login")} iconType={FlowEnums.LOGIN} onClick={(e) => handleButtonClick(e, FlowEnums.LOGIN)} />
      </div>
      <div className={`${showTopup ? "w-1/2" : "w-full"} flex items-center justify-center`}>
        <DriverFlowButton disabled={disableRoster} text={i18n.t("roster")} iconType={FlowEnums.ROSTER} onClick={(e) => handleButtonClick(e, FlowEnums.ROSTER)} />
      </div>
      {showTopup && (
        <div className="w-1/2 flex items-center justify-center">
          <DriverFlowButton text={i18n.t("topUp")} iconType={FlowEnums.SUBMIT} onClick={(e) => handleButtonClick(e, FlowEnums.SUBMIT)} />
        </div>
      )}
      {/* <div className="w-1/2 flex items-center justify-center">
        <DriverFlowButton text={i18n.t("submit")} iconType={FlowEnums.SUBMIT} onClick={(e) => handleButtonClick(e, FlowEnums.SUBMIT)} />
      </div> */}
    </div>
  );
};

export default DriverFlowButtonCard;
